import React from 'react';
import {motion} from 'framer-motion';

const previews=[
  {
    src: 'https://media-manager-c.questera.ai/greta-media/27e565ca62f331bb3d3ca67ccd492f06cd2fa92619ed72ab1d77f8d98c6e5b4cc6657f2d778fcddfd847ef506ea1c4d1/images/aW1hZ2UvanBlZw==/7ff814fddd37c37af823d2da66469438.jpg',
    alt: 'Printable trackers and listening logs from the toolkit',
    label: 'Print it and write on it'
  },
  {
    src: 'https://media-manager-c.questera.ai/greta-media/27e565ca62f331bb3d3ca67ccd492f06cd2fa92619ed72ab1d77f8d98c6e5b4cc6657f2d778fcddfd847ef506ea1c4d1/images/aW1hZ2UvanBlZw==/9d5e6479fbb15ba3a1e59ca8ad186674.jpg',
    alt: 'Feedback conversation one-page guide from Module C',
    label: 'When conversations get difficult'
  },
  {
    src: 'https://media-manager-c.questera.ai/greta-media/27e565ca62f331bb3d3ca67ccd492f06cd2fa92619ed72ab1d77f8d98c6e5b4cc6657f2d778fcddfd847ef506ea1c4d1/images/aW1hZ2UvanBlZw==/ada593563e674b14d192c0c7a23c64d5.jpg',
    alt: 'Question bank guide from Module B',
    label: 'Questions for the person in front of you'
  }
];

function PreviewSection() {
  return (
    <section className="preview-section section">
      <div className="shell">
        <div className="preview-heading">
          <div>
            <p className="eyebrow">A look inside</p>
            <h2>Built for the conversations nobody prepared you for.</h2>
          </div>
          <p>
            Print the page you need, take it into the room, and know what to say next.
          </p>
        </div>

        <div className="preview-grid">
          {previews.map((preview,index)=> (
            <motion.figure
              className="preview-card"
              key={preview.src}
              initial={{opacity: 0,y: 24}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true,margin: '-60px'}}
              transition={{delay: index * 0.08}}
            >
              <img src={preview.src} alt={preview.alt} />
              <figcaption>{preview.label}</figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PreviewSection;